import InfoIcon from "../../Assets/Icons/outline/info-circle-black.svg";
import TrashIcon from "../../Assets/Icons/outline/trash.svg";
import moment from "moment";
import { canSeeBonus, canManageClosedProject } from "../../utils/auth";

const ProjectTable = ({ data, from, handleShow, handleDelete }) => {
	const showBonus = canSeeBonus();
	const canManage = canManageClosedProject();
	return (
		<table className="w-full text-left">
			<thead className="border-t border-b border-black">
				<tr>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">No</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Name</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Points</div>
					</th>
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Is Goal</div>
					</th>
					{showBonus && (
						<th scope="col" className="px-6 py-1">
							<div className="border-e border-black py-1">Bonus</div>
						</th>
					)}
					<th scope="col" className="px-6 py-1">
						<div className="border-e border-black py-1">Closed At</div>
					</th>

					<th scope="col" className="px-6 py-1">
						<div className="py-1">Action</div>
					</th>
				</tr>
			</thead>
			<tbody className="font-light">
				{data?.map((item, index) => {
					const bonus = item?.is_goal ? item?.incentive_type?.bonus || 0 : 0;
					return (
						<tr key={index}>
							<td className="px-6 py-4 w-[100px]">{from++}</td>
							<td className="px-6 py-4">
								<div className="font-semibold">{item?.name}</div>
							</td>
							<td className="px-6 py-4">
								<div className="font-semibold">{item?.total_points}</div>
							</td>

							<td className="px-6 py-4">
								<div className="font-semibold">{item?.is_goal ? "Yes" : "No"}</div>
							</td>
							{showBonus && (
								<td className="px-6 py-4">
									<div className="font-semibold">
										{new Intl.NumberFormat("id-ID", {
											style: "currency",
											currency: "IDR",
											minimumFractionDigits: 0,
										}).format(bonus)}
									</div>
								</td>
							)}
							<td className="px-6 py-4">
								<div className="font-semibold">{moment(item?.closed_at)?.format("DD/MM/YYYY")}</div>
							</td>
							<td className="px-6 py-4 w-[150px]">
								<div className="flex items-center">
									<div className="me-5">
										<button className="button" onClick={() => handleShow(null, "detail", item)}>
											<img src={InfoIcon} alt="" className="w-[25px] h-[25px]" />
										</button>
									</div>
									{canManage && (
										<div className="me-5">
											<button className="button" onClick={() => handleDelete(item)}>
												<img src={TrashIcon} alt="delete" className="w-[25px] h-[25px]" />
											</button>
										</div>
									)}
								</div>
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default ProjectTable;
